import { PrincipalIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { ulid } from "@core/foundation/id";
import {
  createModel,
  createModelId,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { MemoryIdSchema } from "./memory.ts";
import { ProjectIdSchema } from "./project.ts";
import { ID_PREFIX } from "./shared/id-prefix.ts";
import { TriggerConditionSchema } from "./trigger/condition.ts";

const { generateId: generateTriggerId, idSchema: TriggerIdSchema } =
  createModelId({ digestFn: ulid, idPrefix: ID_PREFIX.TRIGGER });

export { TriggerIdSchema };

export const Trigger = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), id: generateTriggerId() };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        condition: TriggerConditionSchema,
        id: TriggerIdSchema,
        memoryId: MemoryIdSchema,
        principalId: PrincipalIdSchema,
        projectId: ProjectIdSchema,
      },
      {
        condition: "The condition the memory fires on.",
        id: "The unique identifier for the trigger.",
        memoryId: "The id of the memory the trigger fires.",
        principalId: "The id of the principal the trigger belongs to.",
        projectId: "The id of the project the trigger belongs to.",
      },
    ),
    derive: {
      create: schema => schema.omit({ id: true }),
      recovery: identity,
      update: noModelUpdate,
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface Trigger extends z.infer<typeof Trigger.schema> {}
